import request from '@/http/request';

// 人力服务列表
export function getInspectionMsg(data) {
  return request({
    url: '/api/v1/ops/get_inspection_msg',
    method: 'post',
    data,
  });
}

export function getInspectionMsgAll(data) {
  return request({
    url: '/api/v1/ops/get_all_inspection_msg',
    method: 'post',
    data,
  });
}

// 演练工单信息
export function getDrillTicketInfo(data) {
  return request({
    url: '/api/v1/ops/get_drill_ticket',
    method: 'post',
    data,
  });
}

export function getShowExport(data) {
  return request({
    url: '/api/v1/ops/get_submaintenance_show_export',
    method: 'post',
    data,
  });
}

export function getHomeDataShow(data) {
  return request({
    url: '/api/v1/ops/get_homedata_show',
    method: 'post',
    data,
  });
}

export function getMapdata(data) {
  return request({
    url: '/api/v1/ops/get_mapdata',
    method: 'post',
    data,
  });
}

export function getMaintenanceShow(data) {
  return request({
    url: '/api/v1/ops/get_maintenance_show',
    method: 'post',
    data,
  });
}

export function getMaintenanceShowAll(data) {
  return request({
    url: '/api/v1/ops/get_maintenance_show_all',
    method: 'post',
    data,
  });
}

export function getSubmaintenanceShow(data) {
  return request({
    url: '/api/v1/ops/get_submaintenance_show',
    method: 'post',
    data: {
      tkid: data.tkid,
      page: data.page,
      size: data.size,
    },
  });
}
export function getSubmaintenanceTkShow(data) {
  return request({
    url: '/api/v1/ops/get_submaintenance_show_tk',
    method: 'post',
    data,
  });
}


export function getMaintenancefixShow(data) {
  return request({
    url: '/api/v1/ops/get_maintenancefix_show',
    method: 'post',
    data,
  });
}
export function getMaintenancefixShowAll(data) {
  return request({
    url: '/api/v1/ops/get_maintenancefix_show_all',
    method: 'post',
    data,
  });
}

export function getCampusList(data) {
  return request({
    url: '/api/v1/ops/campus_ezname',
    method: 'post',
    data,
  });
}
